import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog } from '@angular/material'; 
import { Contacto } from '../../../models/contacto';

@Component({
  selector: 'my-contacto-addedit',
  styles: [],
  templateUrl: './contactoAddEdit.component.html',
  providers: [generalService]
})

export class contactoAddEditComponent {
  public titulo = 'Agregar';
  public contacto: Contacto;
  public contactoAgregar: FormGroup;
  public idCliente;
  public idContacto;

  constructor(private formBuilder: FormBuilder, 
              private _generalService: generalService, 
              public dialog: MatDialog, 
              public dataService: DataService) {
    this.contacto = new Contacto();
    this.idCliente = this.dataService.idCliente;
    this.dataService.guardado = false;
    this.idContacto = this.dataService.id;
  }

  ngOnInit() {
    this.buildForm();

    if(this.dataService.tipo == 'editar') {
      this.consultarContacto();
      this.titulo = "Actualizar"
    }
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  buildForm() {
    this.contactoAgregar = this.formBuilder.group({
      nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      apellidoPaterno: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      apellidoMaterno: this.formBuilder.control(null, [Validators.maxLength(100)]),
      correoElectronico: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      numeroTelefonicoI: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      numeroTelefonicoII: this.formBuilder.control(null, [Validators.maxLength(100)]),
      comentario: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
    });
  }


  onSubmit() {
    let tipo = 'editar';
    let datosContacto = {
      nombre: this.contacto.nombre,
      apellidoPaterno: this.contacto.apellidoPaterno,
      apellidoMaterno: this.contacto.apelldioMaterno,
      correoElectronico: this.contacto.correoElectronico,
      numeroTelefonicoI: this.contacto.numeroTelefonicoI,
      numeroTelefonicoII: this.contacto.numeroTelefonicoII,
      comentario: this.contacto.comentario  }
    let metodo = 'Contacto/insertarContacto/' + this.idCliente;

    if (this.dataService.tipo == 'editar') {
      metodo = 'Contacto/actualizarContacto/' + this.idContacto;  }

    this._generalService.metodoCallParamsPutPost(tipo, datosContacto, metodo).subscribe(
        (result) => { 
          if (result != '') {
            this.dataService.mensajeAlert = result; } 
          else {
            this.dataService.guardado = true; }
          this.cerrarModal();
        },
        (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
        }); 
  }

  consultarContacto() {
    this._generalService.metodoCallParams(this.idContacto, 'Contacto/consultarContacto')
      .subscribe((result) => {
        this.contacto = result[0];
        this.setValues();
        }, 
      (error) => {
        console.log(error);
        this._generalService.toastCall(error);  
    });
  }

  setValues() {
    this.contactoAgregar.controls['nombre'].setValue(this.contacto.nombre);
    this.contactoAgregar.controls['apellidoPaterno'].setValue(this.contacto.apellidoPaterno);
    this.contactoAgregar.controls['apellidoMaterno'].setValue(this.contacto.apelldioMaterno);
    this.contactoAgregar.controls['correoElectronico'].setValue(this.contacto.correoElectronico);
    this.contactoAgregar.controls['numeroTelefonicoI'].setValue(this.contacto.numeroTelefonicoI);
    this.contactoAgregar.controls['numeroTelefonicoII'].setValue(this.contacto.numeroTelefonicoII);
    this.contactoAgregar.controls['comentario'].setValue(this.contacto.comentario);
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente-sae/cliente-sae-agregar-editar/contactos/contactoAddEddit.component.ts